import styled from 'styled-components'

import { color, radius } from '../../../themes'

interface ContainerProps {
  selected?: boolean
}

export const Container = styled.button<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  min-width: 94px;
  color: ${({ selected }) => color(selected ? 'red.01' : 'gray.04')};
  border: 1px solid ${({ selected }) => color(selected ? 'red.01' : 'gray.04')};
  border-radius: ${radius('full')};
  background: none;
  cursor: pointer;
  transition: all 0.2s ease;
`
